import React, { useState, useEffect } from "react"
import { ScreenLayout } from "../components/ScreenLayout"
import { Card, Button, Space } from "antd"
import { API } from "../utils/API"
import OrdersTable from "../components/OrdersTable.js"
import NewOrderModal from "../components/NewOrderModal.js"
import OrdersFileUploadModal from "../components/OrdersFileUploadModal.js"

const Dashboard = () => {
	const [orders, setOrders] = useState([])
	const [newOrderVisible, setNewOrderVisible] = useState(false)
	const [ordersFileUploadVisible, setOrdersFileUploadVisible] = useState(false)

	useEffect(() => {
		API.getOrders().then((res) => setOrders(res.data))
	}, [])

	return (
		<ScreenLayout>
			<Card
				title="Orders"
				style={{ margin: "20px auto", maxWidth: 1400 }}
				extra={
					<Space>
						<Button type="primary" onClick={() => setNewOrderVisible(true)}>
							New Order
						</Button>
						<Button type="default" onClick={() => setOrdersFileUploadVisible(true)}>
							Upload Orders
						</Button>
					</Space>
				}
			>
				<OrdersTable orders={orders} setOrders={setOrders} />

				<NewOrderModal
					newOrderVisible={newOrderVisible}
					setNewOrderVisible={setNewOrderVisible}
					setOrders={setOrders}
				/>

				<OrdersFileUploadModal
					ordersFileUploadVisible={ordersFileUploadVisible}
					setOrdersFileUploadVisible={setOrdersFileUploadVisible}
					setOrders={setOrders}
				/>
			</Card>
		</ScreenLayout>
	)
}

export default Dashboard
